<template>
  <UiContainer class="about-view" :max-width="1100">
    <h1 class="about-view__title">ЛабАктив - B2B‑маркетплейс снабжения</h1>
    <p class="about-view__lead">
      Собираем оборудование, материалы и расходники от разных поставщиков в одном каталоге -
      с понятными карточками товаров, ценами и оформлением заказа под B2B‑закупки.
    </p>

    <div class="about-view__cards">
      <UiCard class="about-view__card">
        <h3 class="about-view__card-title">Широкий каталог</h3>
        <p class="about-view__card-text">
          Оборудование, материалы и расходники для разных отраслей - в одном месте вместо
          десятка разрозненных прайс-листов.
        </p>
      </UiCard>
      <UiCard class="about-view__card">
        <h3 class="about-view__card-title">B2B‑заказы</h3>
        <p class="about-view__card-text">
          Корзина, оформление заказа и статус на каждом шаге - без звонков и переписки, чтобы
          узнать, где заказ.
        </p>
      </UiCard>
      <UiCard class="about-view__card">
        <h3 class="about-view__card-title">Поставщики и ассортимент</h3>
        <p class="about-view__card-text">
          Поставщики сами обновляют предложения, покупатели видят актуальные цены и наличие.
        </p>
      </UiCard>
    </div>

    <div class="about-view__block">
      <h2 class="about-view__heading">Почему это удобнее прайс-листов</h2>
      <p class="about-view__text">
        Обычно закупка оборудования - это созвоны с несколькими поставщиками и сверка цен по
        разным файлам. Мы собираем всё в одном каталоге: поставщикам проще показать ассортимент,
        а закупщикам - быстрее найти нужный товар, сравнить предложения и оформить заказ, не
        покидая сайт.
      </p>
    </div>

    <UiCard class="about-view__cta">
      <h2 class="about-view__cta-title">Связаться с нами</h2>
      <p class="about-view__cta-text">
        Хотите подключиться как поставщик или поискать оборудование под требования? Напишите нам.
      </p>
      <div class="about-view__cta-buttons">
        <UiButton to="/suppliers/register">Поставщикам</UiButton>
        <UiButton variant="secondary" to="/contacts">Контакты</UiButton>
      </div>
    </UiCard>
  </UiContainer>
</template>

<script setup lang="ts">
import UiButton from '@/shared/ui/UiButton.vue'
import UiCard from '@/shared/ui/UiCard.vue'
import UiContainer from '@/shared/ui/UiContainer.vue'
</script>

<style scoped>
.about-view {
  padding-top: 40px;
  padding-bottom: 64px;
}

.about-view__title {
  margin: 0 0 16px;
  font-size: 28px;
  font-weight: 700;
}

.about-view__lead {
  margin: 0 0 32px;
  font-size: 16px;
  line-height: 1.6;
  color: #475569;
}

.about-view__cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}

@media (max-width: 960px) {
  .about-view__cards {
    grid-template-columns: minmax(0, 1fr);
  }
}

.about-view__card {
  padding: 20px;
}

.about-view__card-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
}

.about-view__card-text {
  margin: 0;
  font-size: 14px;
  color: #586578;
  line-height: 1.5;
}

.about-view__block {
  max-width: 720px;
  margin-bottom: 48px;
}

.about-view__heading {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 600;
}

.about-view__text {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #475569;
}

.about-view__cta {
  padding: 24px;
}

.about-view__cta-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
}

.about-view__cta-text {
  margin: 0 0 20px;
  font-size: 14px;
  color: #586578;
}

.about-view__cta-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
